<template>
  <v-navigation-drawer :width="width" v-model="drawer" absolute temporary>
    <v-img :aspect-ratio="16 / 9" src="@/assets/images/content/drums.jpg">
      <!--
        <v-row align="end" class="lightbox white--text pa-2 fill-height">
          <v-col>
            <div class="subheading">Usuario</div>
            <div class="body-1">heyfromjonathan@gmail.com</div>
          </v-col>
        </v-row>
        -->
    </v-img>

    <v-list>
      <template v-for="(item, i) in items">
        <v-divider v-if="item.divider" :key="i"></v-divider>
        <!--          
          <v-list-item v-else :key="item.title" @click>
-->
        <v-list-item v-else :key="item.title" @click="showMenu(item.title)">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Vue from "vue";

import { mapState } from "vuex";

export default {
  props: ["value"],
  data: () => ({
    width: 300,
    drawer: false,
    items: [
      { icon: "mdi-blogger", title: "Blog Drops" },
      { divider: true },
      { icon: "mdi-facebook", title: "Facebook" },
      { divider: true },
      { icon: "mdi-playlist-music", title: "Playlist" },
      { divider: true },
      { icon: "mdi-mail", title: "Entre em contato" },
      { divider: true },
      { icon: "mdi-account-cash", title: "Seja nosso patrocinador" },
      { divider: true },
      { icon: "mdi-account-group", title: "Quem somos" },
      { divider: true },
      /*
        { icon: 'drafts', title: 'Drafts' },
        { divider: true },
        { icon: 'mail', title: 'All mail' },
        { icon: 'delete', title: 'Trash' },
        { icon: 'error', title: 'Spam' },
        */
    ]
  }),

  watch: {
    value(val) {
      console.log("mudando o value", val);

      if (!val) return;

      this.drawer = val;

      this.$emit("input", false);
      /*
      if (val.length < prev.length) {
        let difference = prev.filter(x => !val.includes(x));

        console.log(difference);
      }
*/
    }
  },

  computed: {
    ...mapState([
      // map this.count to store.state.count
      "IsBlogPost",
      "IsFacebook",
      "IsMobile"
    ])
  },
  methods: {
    showMenu: function(title) {
      this.drawer = false;

      if (title === "Blog Drops") {
        this.$store.commit("setIsBlogPost", true);
      } else if (title === "Facebook") {
        this.$store.commit("setIsFacebook", true);
      } else if (title === "Entre em contato") {
        this.$store.commit("setIsContato", true);
      } else if (title === "Seja nosso patrocinador") {
        this.$store.commit("setIsPatrocinador", true);
      } else if (title === "Playlist") {
        this.$store.commit("setIsSpotify", true);
      } else if (title === "Quem somos") {
        this.$store.commit("setIsRedesSociais", true);
      }
    }
  }
};
</script>

<style scoped>
.v-navigation-drawer {
  transition: none !important;
}

.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  );
}
</style>
